let _ = require("ES/lib/lodash");

export default function (event) {
    let company = null;
    var buyer_names = _.map(_.get(event, "Buyers", {}), function (Buyer) {
        company = _.get(Buyer, "company");
        return [Buyer.firstname, Buyer.lastname].join(" ");
    });
    if (_.isEmpty(buyer_names)) {
        buyer_names = ['The client'];
    }

    let r = buyer_names.join(', ');

    if (!_.isEmpty(company)) {
        r += ", " + company;
    }
    return r;
}



// WEBPACK FOOTER //
// ./src/utils/getBuyerNameCompany.js